import styled from 'styled-components';

import {
  Modal as SemanticModal,
} from 'semantic-ui-react';

import {
  Button as ButtonLayoutComponent,
  Text as TextLayoutComponent,
  Loader as LoaderLayoutComponent,
  Checkbox as CheckboxLayoutComponent,
} from '@playbookux/playbook-web-core';

const Modal = styled(SemanticModal)``;

const ContainerContent = styled.div`
  display: flex;
  flex-direction: column;
  font-size: 20px;
  padding: 24px 34px;
`;

const LoaderContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 30px;
`;

const Header = styled(TextLayoutComponent.Header)`
  margin-bottom: 6px;
`;

const Button = styled(ButtonLayoutComponent)`
  &.ui.button {
    width: ${({ oneButton }) => (oneButton ? '80px' : ' 144px')};
  }
`;

const ButtonInverted = styled(ButtonLayoutComponent.Inverted)`
    &.ui.button {
    width: 144px;
  }
`;

const Loader = styled(LoaderLayoutComponent)`
`;

const ContainerButton = styled.div`
  display: flex;
  width: 100%;
  justify-content: ${({ oneButton }) => (oneButton ? 'center' : 'space-between')};
  padding: 0 26px;
  margin-top: 20px;
`;

const ContainerCheckbox = styled.div`
  display: flex;
  flex-direction: column;
`;

const CheckboxContent = styled.div`
  margin-top: 8px;
`;

const TextSecondary = styled(TextLayoutComponent.Secondary)`
  ${({ small }) => small && 'margin-left: 26px;'};
  font-size: ${({ small }) => (small ? '12px' : '14px')};

  & + &{
    margin-top: 20px;
  }
`;

const Checkbox = styled(CheckboxLayoutComponent).attrs(({ theme }) => ({ color: `${theme.color.textSecondary} !important` }))``;

const ContainerTextSize = styled(TextLayoutComponent.Secondary)`
  text-align: center;
  padding: 24px;
  font-size: 18px;
`;

export {
  Modal,
  ContainerContent,
  Header,
  ButtonInverted,
  Button,
  ContainerButton,
  TextSecondary,
  Checkbox,
  ContainerCheckbox,
  CheckboxContent,
  ContainerTextSize,
  Loader,
  LoaderContainer,
};
